<template>
    <div class="my">
        <div class="info flex f-v-center f-h" style="position: relative;">
            <img :src="user.userInfo.url || require('@/assets/icons/user.png')"/>
            <div  class="name">
                <div style="font-weight: bold; color: #333;">{{user.userInfo.real_name}}</div>
                <span v-if="user.userInfo.phone">{{user.userInfo.phone || '缘木子'}}</span>
                <span style="color: #40D9C7; "
                      v-else
                      @click="router.push('/login')">手机号登录</span>
            </div>

            <button class="btn flex f-v-center"

                    @click="router.push('/carList')">
                <img :src="require('@/assets/icons/p.png')"/>
                <span>我的卡包</span>
            </button>


        </div>



        <template v-if="!user.userInfo.is_coach">

            <div class="block">
                <div class="nt flex f-h f-sb f-v-center">
                    <div class="txt">我的统计</div>
                    <div class="more" >
                        <!--<span>2024-02</span>
                        <img :src="require('@/assets/icons/down.png')"/>-->
                    </div>
                </div>

                <div class="count-block flex f-v-center f-sb">
                    <span class="tag">团课</span>
                    <div class="flex f-v f-grow">
                        <span class="n">{{data.statis.dumpling_two}}</span>
                        <span>已完成</span>
                    </div>
                    <div class="flex f-v f-grow">
                        <span class="n">{{data.statis.team}}</span>
                        <span>剩余</span>
                    </div>

                    <div class="flex f-v f-grow">
                        <span class="n">{{data.statis.dumpling_one}}</span>
                        <span>已预约</span>
                    </div>
                </div>
                <div class="count-block flex f-v-center f-sb">
                    <span class="tag">私教</span>
                    <div class="flex f-v f-grow">
                        <span class="n">{{data.statis.personal_two}}</span>
                        <span>已完成</span>
                    </div>

                    <div class="flex f-v f-grow">
                        <span class="n">{{data.statis.personal}}</span>
                        <span>剩余</span>
                    </div>

                    <div class="flex f-v f-grow">
                        <span class="n">{{data.statis.personal_one}}</span>
                        <span>已预约</span>
                    </div>
                </div>
            </div>
            <div class="block">
                <div class="nt flex f-h f-sb f-v-center">
                    <div class="txt">团课预约列表 ({{data.groupTotal}})</div>
                    <div class="more" @click="router.push('/courseList')">
                        <span>查看更多></span>
                    </div>
                </div>

                <loading v-if="data.loading"/>
                <empty v-if="!data.loading && data.groupList.length <= 0" hint="暂无未完成课程~"/>

                <div class="course-block"
                     v-for="(item, i) in data.groupList"
                     :key="i">
                    <div class="title flex f-v">
                        <div >
                            <span class="n">{{item.name}}</span>
                            <span class="tag">团课</span>
                            <span class="tag" v-if="item.type === '1'">预约</span>
                            <span class="tag" v-if="item.type === '2'">排队</span>
                        </div>
                        <div class="date">{{t.formatDate(item.start, 'yyyy/MM/dd hh:mm')}}-{{t.formatDate(item.end, 'hh:mm')}}</div>
                    </div>
                    <div class="state flex f-sb f-v-center" >
                        <div class="t">
                            <span class="t1">教练</span>
                            <span class="t2">{{item.coach_name}}</span>
                        </div>
                        <div class="t">
                            <span class="t1">状态</span>
                            <span class="t2" v-if="item.status === '1'">未完成</span>
                            <span class="t2" v-if="item.status === '2'">已完成</span>
                        </div>
                        <button class="btn" @click="cancelJoinCourse(item)">取消</button>
                    </div>
                </div>

            </div>

            <div class="block">
                <div class="nt flex f-h f-sb f-v-center">
                    <div class="txt">私教预约列表 ({{data.privateTotal}})</div>
                    <div class="more" @click="router.push('/ppList')">
                        <span>查看更多></span>
                    </div>
                </div>

                <loading v-if="data.loading"/>
                <empty v-if="!data.loading && data.privateList.length <= 0" hint="暂无私教~"/>

                <div class=" pp flex f-h "
                     v-for="(item, i) in data.privateList"
                     :key="i">

                    <div class="img flex f-v-center ">
                        <img :src="item.url ? (req.host + item.url) : require('@/assets/icons/user.png') "/>
                    </div>
                    <div class="str f-grow flex f-v f-sa">
                        <div class="s1 flex f-sb f-v-center">
                            <span>{{item.name}}</span>
                            <button class="btn" @click="cancelJoin(item)">取消预约</button>
                        </div>
                        <div class="s2 txt-ellipsis">预约时间 {{item.day}} {{item.start}}-{{item.end}}</div>
                        <div class="s2 txt-ellipsis" v-if="item.room_name">{{item.venue_name}} - {{item.room_name}}</div>
                    </div>
                </div>

            </div>

            <div class="block">
                <div class="nt flex f-h f-sb f-v-center">
                    <div class="txt">购买记录 ({{data.orderTotal}})</div>
                    <div class="more" @click="router.push('/buyList')">
                        <span>查看更多></span>
                    </div>
                </div>

                <div class="buy-list">

                    <loading v-if="data.loading"/>
                    <empty v-if="!data.loading && data.orderList.length <= 0" hint="暂无购买记录~"/>

                    <div class="item flex f-sb f-v-center"
                         v-for="(item, k) in data.orderList"
                         :key="k">
                        <img :src="require('@/assets/icons/bc.png')"/>
                        <div class="ginfo flex f-v f-grow">
                            <div class="t1 flex f-sb">
                                <span class="f-grow txt-ellipsis">{{item.name}}</span>
                                <div>
                                    <span style="font-size: .24rem;">¥</span>
                                    <span style="font-weight: bold;">{{item.money}}</span>
                                </div>
                            </div>
                            <div class="date">{{item.create_time}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="user.userInfo.is_coach">

            <div class="block">
                <div class="nt flex f-h f-sb f-v-center">
                    <div class="txt">我的统计</div>
                    <div class="more" >
                        <!--<span>2024-02</span>
                        <img :src="require('@/assets/icons/down.png')"/>-->
                    </div>
                </div>

                <div class="count-block flex f-v-center f-sb">
                    <span class="tag">团课</span>
                    <div class="flex f-v f-grow">
                        <span class="n">{{data.coachStatis.dumpling_two}}</span>
                        <span>已完成</span>
                    </div>
                    <div class="flex f-v f-grow">
                        <span class="n">{{data.coachStatis.dumpling_one}}</span>
                        <span>待上课</span>
                    </div>

                </div>
                <div class="count-block flex f-v-center f-sb">
                    <span class="tag">私教</span>
                    <div class="flex f-v f-grow">
                        <span class="n">{{data.coachStatis.personal_two}}</span>
                        <span>已完成</span>
                    </div>
                    <div class="flex f-v f-grow">
                        <span class="n">{{data.coachStatis.personal_one}}</span>
                        <span>待上课</span>
                    </div>
                </div>
            </div>

            <div class="block">
                <div class="nt flex f-h f-sb f-v-center">
                    <div class="txt">教练日历</div>
                    <div class="more" @click="showBlockModal()" style="color:#FF6B6B">设置休息</div>
                    <div class="more" >
                        <!--<span>2024-02</span>
                        <img :src="require('@/assets/icons/down.png')"/>-->
                    </div>
                </div>

                <div class="coach-wrap">
                    <div class="date flex f-sa">
                        <span v-for="(d, i) in data.coachDate"
                              :class="{sel: d.select}"
                              @click="selCoachDate(d)"
                        >{{d.str}}({{data.dayStr[i]}})</span>
                    </div>

                    <div class="t-list">
                        <div class="item flex f-v-center"
                             v-for="(item, i) in data.coachStatis.list"
                             :class="item.state"
                             :key="i">
                            <span>{{item.start}}-{{item.end}}</span>
                            <img v-if="item.url" @click="showChangeTimeDialog(item)" :src="item.url" style="border-radius: 50%; width:2em;"/>
                            <img v-if="item.group" :src="require('@/assets/icons/tuan.png')"/>
                            <img v-if="item.timeout === 2" :src="require('@/assets/icons/success1.png')"/>

                        </div>
                        <empty v-if="!data.loading && data.coachStatis.list.length <= 0" hint="暂无安排~"/>

                    </div>

                    <!-- 已设置的休息时段 -->
                    <div class="block-list" style="margin-top:16px;padding-top:12px;border-top:1px dashed #ddd">
                        <div style="font-size:13px;color:#999;margin-bottom:8px">已设休息时段</div>
                        <loading v-if="data.blockLoading"/>
                        <empty v-if="!data.blockLoading && data.blockList.length<=0" hint="未设置休息~"/>
                        <div v-for="b in data.blockList" :key="b.id" style="display:flex;justify-content:space-between;align-items:center;padding:6px 0;font-size:13px;border-bottom:1px solid #f5f5f5">
                            <div>
                                <span>{{b.day}} {{b.start}}-{{b.end}}</span>
                                <span v-if="b.repeat_type==='weekly'" style="background:#FF6B6B;color:#fff;font-size:10px;padding:1px 4px;border-radius:3px;margin-left:4px">每周</span>
                                <span v-if="b.reason" style="color:#999;margin-left:4px;font-size:11px">{{b.reason}}</span>
                            </div>
                            <span @click="removeBlock(b)" style="color:#e74c3c;font-size:11px;cursor:pointer">删除</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- 设置休息弹窗 -->
        <transition-group name="fade">
            <div class="confirm-content buy-dlg" v-if="data.showBlock" style="padding:20px">
                <div class="title">设置休息时段</div>
                <div style="margin:12px 0">
                    <label style="font-size:13px;color:#666">日期</label>
                    <input type="date" v-model="data.blockForm.day" style="width:100%;padding:8px;border:1px solid #ddd;border-radius:6px;margin-top:4px"/>
                </div>
                <div style="display:flex;gap:10px;margin:12px 0">
                    <div style="flex:1">
                        <label style="font-size:13px;color:#666">开始</label>
                        <input type="time" v-model="data.blockForm.start" style="width:100%;padding:8px;border:1px solid #ddd;border-radius:6px;margin-top:4px"/>
                    </div>
                    <div style="flex:1">
                        <label style="font-size:13px;color:#666">结束</label>
                        <input type="time" v-model="data.blockForm.end" style="width:100%;padding:8px;border:1px solid #ddd;border-radius:6px;margin-top:4px"/>
                    </div>
                </div>
                <div style="margin:12px 0">
                    <label style="font-size:13px;color:#666;display:flex;align-items:center;gap:8px">
                        <input type="checkbox" v-model="data.blockForm.weekly" style="width:16px;height:16px"/> 每周重复（同星期）
                    </label>
                </div>
                <div style="margin:12px 0">
                    <label style="font-size:13px;color:#666">原因（选填）</label>
                    <input type="text" v-model="data.blockForm.reason" placeholder="如：外出培训" style="width:100%;padding:8px;border:1px solid #ddd;border-radius:6px;margin-top:4px"/>
                </div>
                <div class="ctl flex f-sa" style="margin-top:16px">
                    <button class="btn cancel" @click="data.showBlock=false">取消</button>
                    <button class="btn ok" @click="saveBlock()">确认</button>
                </div>
            </div>
            <div class="confirm-bg" v-if="data.showBlock" @click="data.showBlock=false"></div>
        </transition-group>

        <transition-group name="fade">
            <div class="confirm-content buy-dlg time-select" v-if="data.showCoach">
                <div class="title">预约教练</div>
                <div class="msg flex f-wrap" >
                    <div v-for="(t, i) in data.timeList"
                         :class="{'used': t.isUsed, 'sel': t.select}"
                         @click="selectTimeF(t, i)"
                         class="time-item">
                        <span>{{t.h}}:{{t.m}}</span>
                    </div>

                </div>
                <div class="hint" style="margin: -20px 0 20px;">提示: 预约需扣除5格时间</div>

                <div class="ctl flex f-sa">
                    <button class="btn cancel"
                            @click="data.showCoach = false">取消</button>
                    <button class="btn ok"
                            @click="confirmChange()">确认</button>

                </div>
            </div>
            <div class="confirm-bg" v-if="data.showCoach"></div>
        </transition-group>
        <FloatBtn :btm="-20" @click="init(true)">
            <span style="font-weight: bold;color: #fff;">刷新</span>
        </FloatBtn>

        <FloatBtn :btm="-150">
            <wx-open-subscribe
                    @success="t.showToast('订阅成功~')"
                    @error="t.showToast('订阅失败')"
                    template="HX_vqEIqRVfvUXsMdWWV1us4JR0mOngAd-zLNVlSVLY,dtm8jR9Rab87EmlCVlAwXs8oylnztkLzSBLjyPdn_RU"
                    id="subscribe-btn2">
                <component :is="'script'" type="text/wxtag-template" slot="style">
                    <component :is="'style'">
                        .subscribe-btn2 {
                        font-size: 14px;
                        padding: 5px 10px;
                        color: #fff;
                        width: 100px;
                        font-weight: bold;
                        }
                    </component>
                </component>
                <component :is="'script'" type="text/wxtag-template">
                    <span class="subscribe-btn2">订阅消息</span>
                </component>
            </wx-open-subscribe>
        </FloatBtn>
    </div>

</template>
<script setup>
    import FloatBtn from '@/components/FloatBtn.vue';

    import confirm from '@/lib/confirm.js';
    import empty from '@/components/empty.vue';
    import Loading from '@/components/LLoading.vue';
    import router from '../router/index.js';
    import waitInit from '@/lib/init.js';
    import api from '@/api/api.js';
    import req from '@/api/request.config.js';
    import t from '@zh-or/lib';
    import u from '@/lib/tools.js';
    import {ref, reactive} from 'vue';
    import {userStore} from '@/lib/store.js';

    let user = userStore();
    let data = reactive({
        loading: false,
        showBlock: false,
        blockLoading: false,
        blockList: [],
        blockForm: {day:'',start:'',end:'',weekly:false,reason:''},
        statis: {
            //普通用户
            "personal": "",  //剩余私教
            "team": "0",  //剩余团课
            "personal_one": 0,  //已预约私教
            "personal_two": 0,  //已完成私教
            "dumpling_one": 0,   //已预约团课
            "dumpling_two": 0,   //已完成团课

        },
        coachStatis: {
            //教练
            "personal_one": 4,  //待上私教课
            "personal_two": 0,//以上私教课
            "dumpling_one": 1,  //待上团课
            "dumpling_two": 2,  //已上团课
            personal: [],
            group: [],
            list: [],
        },
        groupList: [],
        groupTotal: 0,

        privateList: [],
        privateTotal: 0,

        orderList: [],
        orderTotal: 0,

        coachDate: [
            getDateAndAdd(0),
            getDateAndAdd(1),
            getDateAndAdd(2),
        ],
        dayStr: ['今天', '明天', '后天'],

        showCoach: false,
        timeList: [],
        changeObj: null,
        selDate: '',
    });


    waitInit(() => {
        init();
    });

    function getDateAndAdd(day, fmt) {
        day = day || 0;
        fmt = fmt || 'yyyy-MM-dd';
        let date = new Date();
        date.setDate(date.getDate() + day);
        return {
            str: t.formatDate(date, fmt),
            date: date,
            sel: false,
        }
    }

    function selCoachDate(d) {
        data.coachDate.forEach(_ => _.select = false);
        data.selDate = t.formatDate(d.date, 'yyyy-MM-dd');
        d.select = true;
        return new Promise((resolve, reject) => {
            api.getCoachStatis({
                moon: t.formatDate(d.date, 'yyyy-MM'),
                time: t.formatDate(d.date, 'yyyy-MM-dd')
            })
                .then(res => {
                    if(res.code === 1) {
                        t.clone(res.data, data.coachStatis);

                        data.coachStatis.list = [];

                        data.coachStatis.personal.forEach(p => {
                            let url = require('@/assets/icons/user.png');
                            if(p.url) {
                                url = req.host + p.url;
                            }

                            data.coachStatis.list.push({
                                date: t.parseDate(t.formatDate(d.date, 'yyyy-MM-dd ') + p.start),
                                dateEnd: t.parseDate(t.formatDate(d.date, 'yyyy-MM-dd ') + p.end),
                                start: p.start,
                                end: p.end,
                                group: false,
                                url: url,
                                id: p.id,
                            });
                        })

                        data.coachStatis.group.forEach(p => {
                            data.coachStatis.list.push({
                                date: t.parseDate(t.formatDate(d.date, 'yyyy-MM-dd ') + p.start),
                                dateEnd: t.parseDate(t.formatDate(d.date, 'yyyy-MM-dd ') + p.end),
                                start: p.start,
                                end: p.end,
                                group: true,
                            });
                        })
                        let now = Date.now();
                        data.coachStatis.list.forEach(p => {

                            if(now < p.date.getTime()) {//未开始
                                p.timeout = 0;
                                p.state = 'wait';
                            } else if(now > p.dateEnd.getTime()) {//已结束
                                p.timeout = 2;
                                p.state = 'over';
                            } else {
                                p.timeout = 1;
                                p.state = 'doing';
                            }

                        })

                        data.coachStatis.list.sort((a, b) => a.date.getTime() - b.date.getTime());
                    }
                    resolve();
                })
                .catch(e => {
                    console.error('获取教练统计出错:', e);
                    reject();
                })
        });
    }

    function init(hint) {
        data.loading = true;

        let isCoach = user.userInfo.is_coach;
        let tasks;
        if(isCoach) {
            tasks = Promise.all([selCoachDate(data.coachDate[0]), loadBlocks()]);
        } else {
            tasks = Promise.all([
                api.getStatis(),
                api.getMyGroup({page: 1, status: 1}),
                api.getMyPrivate({page: 1, status: 1}),
                api.getMyOrderList({page: 1})
            ]);
        }
        tasks
            .then((results) => {
                let isCoach = user.userInfo.is_coach;
                if(!isCoach) {
                    let statis = results[0], group = results[1], p = results[2], order = results[3];
                    if(statis.code === 1) {
                        t.clone(statis.data, data.statis);
                    }
                    if(group.code === 1) {
                        data.groupList = (group.data.data || []).map(_ => {
                            _.start = _.day + ' ' + _.start;
                            _.end = _.day + ' ' + _.end;
                            return _;
                        });
                        data.groupTotal = group.data.total;
                    }
                    if(p.code === 1) {
                        data.privateList = p.data.data;
                        data.privateTotal = p.data.total;
                    }
                    if(order.code === 1) {
                        data.orderList = order.data.data;
                        data.orderTotal = order.data.total;
                    }
                }
                data.loading = false;
                if(hint) {
                    t.showToast('刷新完成!');
                }
            })
            .catch(e => {
                t.showToast('未获取到数据~');
                console.error('加载出错:', e);
            })
    }

    function cancelJoin(item) {
        confirm('提示', `确定取消 <strong>${item.name}</strong> 的预约吗?`)
            .then(_ => {
               t.showWait('取消中...');
               api.cancelUseCoach({
                    id: item.id
               })
                   .then(res => {
                       t.hideWait();
                       if(res.code === 1) {
                           t.showToast('取消预约成功!');
                           init();
                       }
                   })
                   .catch(e => {
                       console.error('取消预约失败:', e);
                       t.hideWait();
                       t.showToast('取消预约失败, 网络错误~');
                   })
            });
    }

    function cancelJoinCourse(item) {
        confirm('提示', `确定取消 ${item.name} 吗?`)
            .then(() => {
                t.showWait('取消中');
                api.cancelJoin({
                    pid: item.pid
                })
                    .then(res => {
                        t.hideWait();
                        if(res.code === 1) {
                            t.showToast('取消成功');
                            init();
                        }
                    })
                    .catch(e => {
                        console.error('取消失败:', e);
                        t.hideWait();
                        t.showToast('取消失败, 网络错误!');
                    })
            })
    }

    function showBlockModal(){
        let d=new Date();data.blockForm.day=d.toISOString().substr(0,10);
        data.blockForm.start='';data.blockForm.end='';data.blockForm.weekly=false;data.blockForm.reason='';
        loadBlocks();data.showBlock=true;
    }
    async function loadBlocks(){
        data.blockLoading=true;
        try{
            let r=await api.coachBlocks({});
            if(r.code===1) data.blockList=r.data.data||[];
        }catch(e){console.error('加载休息时段失败:',e)}
        data.blockLoading=false;
    }
    async function saveBlock(){
        let f=data.blockForm;
        if(!f.day||!f.start||!f.end){t.showToast('请填写完整');return}
        if(f.start>=f.end){t.showToast('结束时间必须晚于开始时间');return}
        let dayOfWeek=new Date(f.day).getDay();
        let d={day:f.day,start:f.start,end:f.end,reason:f.reason||'',repeat_type:f.weekly?'weekly':'once',repeat_day:f.weekly?dayOfWeek:0};
        try{
            let r=await api.coachBlock(d);
            if(r.code===1){t.showToast('已设置');data.showBlock=false;loadBlocks();selCoachDate(data.coachDate.find(x=>x.select)||data.coachDate[0])}
            else t.showToast(r.msg||'设置失败')
        }catch(e){t.showToast('网络错误')}
    }
    async function removeBlock(b){
        if(!confirm('确定删除该休息时段？'))return;
        try{
            let r=await api.coachUnblock({id:b.id});
            if(r.code===1){t.showToast('已删除');loadBlocks();selCoachDate(data.coachDate.find(x=>x.select)||data.coachDate[0])}
            else t.showToast(r.msg||'删除失败')
        }catch(e){t.showToast('网络错误')}
    }
    function showChangeTimeDialog(u) {
        data.changeObj = u;
        data.timeList = [];
        let stepTime = 15;//min
        let endHours = 22;//
        let timeStr = data.selDate + ' 07:00:00';

        let time = t.parseDate(timeStr);

        time.setHours(7);
        time.setMinutes(0);
        time.setSeconds(0);
        time.setMilliseconds(0);

        while(true) {
            data.timeList.push({
                h: t.formatDate(time, 'hh'),
                m: t.formatDate(time, 'mm'),
                full: t.formatDate(time, 'yyyy-MM-dd hh:mm'),
                hm: t.formatDate(time, 'hh:mm'),
                isUsed: false,
            });
            time.setMinutes(time.getMinutes() + stepTime);
            if(time.getHours() >= endHours && time.getMinutes() != 0) {
                break;
            }
        }

        data.showCoach = true;
    }


    function selectTimeF(t2, i) {
        data.timeList.forEach(v => {
            v.select = false;
        });
        if(!selectTime(t2, i)) {
            t.showToast('不足5格时间!');
        }
    }

    function selectTime(_t, i, count) {
        count = count || 0;
        if(count >= 5) {
            return true;
        }
        let t = data.timeList[i + count];
        if(!t) {
            //t.showToast('请选择满3个')
            return false;
        }
        if(!t.isUsed && selectTime(t, i, (count || 0) + 1)) {
            t.select = true;
            return true;
        }
        return false;
    }

    function confirmChange() {
        let times = data.timeList.filter(_ => _.select);
        if(times.length < 4) {
            t.showToast('不满5格时间!');
            return ;
        }
        data.showCoach = false;

        confirm('提示', `确认修改为 ${times.map(_ => _.hm).join(', ')} 吗?`)
            .then(_ => {
                t.showWait('正在修改...');
                let s = times[0],
                    e = times[times.length - 1];
                api.changeUserTime({
                    id: data.changeObj.id,
                    start: `${s.h}:${s.m}`,
                    end: `${e.h}:${e.m}`,
                })
                    .then(res => {
                        t.hideWait();
                        if(res.code === 1) {
                            t.showToast('修改成功!');
                            init();
                        }
                    })
                    .catch(e => {
                        t.hideWait();
                        t.showToast('修改失败, 网络错误!');
                    })
            })
            .catch(_ => {
                data.showCoach = true;
            });
    }
</script>
<style lang="scss">
    .my {
        height: 100%;
        overflow-y: auto;
        padding: $page-lr-pd;

        .info {
            background: #FFFFFF;
            box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.05);
            border-radius: 10px 10px 10px 10px;
            padding: 30px 20px;
            background: #fff url("~@/assets/icons/my-bg.png") no-repeat center bottom;
            background-size: 100% auto;
            position: relative;

            color: rgba(0,0,0,0.8);

            img {
                height:5em;
                width: 5em;
                border-radius: 50%;
            }

            .name {
                font-size: .36rem;
                word-break: break-all;
                margin-left: 10px;
                font-weight: bold;
            }

            .btn {
                position: absolute;
                right: 15px;
                top: 15px;
                background: #FFC547;
                border-radius: 20px 20px 20px 20px;
                font-size: .24rem;
                padding: 5px 10px;
                color: #fff;

                img {
                    width: 1em;
                    height: 1em;
                    margin-right: 5px;
                }
            }
        }


        .block {
            background-color: #fff;
            border-radius: 10px 10px 10px 10px;
            padding: 10px;
            margin-top: 10px;
            box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.05);

            .nt {
                padding-bottom: 10px;

                .txt {
                    color: #606060;
                    font-size: .32rem;
                    border-left: 4px solid #40D9C7;
                    padding-left: 10px;
                }

                .more {
                    color: #40D9C7;
                    font-size: .24rem;

                    img {
                        height: 1em;
                        width: 1em;
                    }
                }
            }

            .count-block {
                font-size: .24rem;
                background: #F7F7F7;
                border-radius: 10px 10px 10px 10px;
                padding: 10px 0;
                margin-bottom: 10px;

                .tag {
                    color: #fff;
                    padding: 3px 10px;
                    margin: 0 15px;
                    background: #FFC547;
                    border-radius: 20px 20px 20px 20px;
                }

                .flex {
                    text-align: center;
                    color: #606060;

                    .n {
                        font-size: .42rem;
                        font-weight: bold;
                        margin-bottom: 5px;
                    }
                }
            }

            .coach-wrap {
                .date {
                    span {
                        color: #40D9C7;
                        border: 1px solid #40D9C7;
                        padding: 4px 5px;
                        border-radius: 4px;
                    }

                    .sel {
                        background-color: #40D9C7;
                        color: #fff;
                    }
                }

                .t-list {
                    padding-top: 20px;

                    .item {
                        padding: 10px;

                        span {
                            font-weight: bold;
                            margin-right: 10px;
                        }

                        img {
                            height: 2em;
                        }

                        &.wait {
                            color: #40D9C7;
                        }

                        &.over {
                            color: #8E8E8E;
                        }

                        &.doing {
                            color: #FFC547;
                        }


                        .xx {
                            position: absolute;
                            right: 0;
                            top: 0;
                            padding: 5px 10px;
                            color: #40D9C7;
                        }
                    }
                }
            }

        }
    }
</style>
